import { StoreApi, UseBoundStore, useStore } from "zustand";
import {
  MailContactsStoreType,
  mailContactsStore,
} from "./mail-contacts-store";
import {
  mailContactsPersistentStore,
  MailContactsPersistentStoreType,
} from "./mail-contacts-persistent-store";

export const useMailContactsStore = useStore.bind(
  null,
  mailContactsStore.getStore()
) as UseBoundStore<StoreApi<MailContactsStoreType>>;

export const useMailContactsPersistentStore = useStore.bind(
  null,
  mailContactsPersistentStore.getStore()
) as UseBoundStore<StoreApi<MailContactsPersistentStoreType>>;
